import { LiveStreamStatus } from './presenter-enums';

export const PRESENTER_MOBILE_BREAK_POINT = 1023;
export const PRESENTER_SLIDES_ASSET_RADIX = 10;
export const SLIDE_NOT_EXIST_MESSAGE = 'Slide does not exist, please refresh the page';

export const liveStreamStatusNames = {
  [LiveStreamStatus.STAND_BY]: 'Standby',
  [LiveStreamStatus.BROADCASTING]: 'LIVE',
  [LiveStreamStatus.START_BROADCASTING]: 'LIVE',
  [LiveStreamStatus.INTERMISSION]: 'Intermission',
  [LiveStreamStatus.END_BROADCASTING]: 'Ended',
  [LiveStreamStatus.ENDED]: 'Ended'
};

export const liveStreamStatusFromApi = (status: string): LiveStreamStatus => {
  switch (status){
    case 'standBy':
      return LiveStreamStatus.STAND_BY;
    case 'broadcasting':
      return LiveStreamStatus.BROADCASTING;
    case 'intermission':
      return LiveStreamStatus.INTERMISSION;
    case 'ended':
      return LiveStreamStatus.ENDED;
    default:
      return LiveStreamStatus.STAND_BY;
  }
};